interface BaseProps {
  title?: string;
  titleChildren?: React.ReactNode;
  required?: boolean;
  value?: string | number | undefined;
  children?: React.ReactNode;
  className?: string;
}
const BaseSection = ({ title, value, children, required, titleChildren, className = "" }: BaseProps) => {
  return (
    <section className={`contents-container__grid`}>
      <div className={`contents-container__grid-index ${className ? className : ""}`}>
        {titleChildren === undefined ? <p className={`${required ? "required" : ""} pre-formatted`}>{title}</p> : titleChildren}
      </div>
      <div className="contents-container__grid-contents">{children === undefined ? <p>{value}</p> : children}</div>
    </section>
  );
};

export default BaseSection;
